module.exports = new __parcel__URL__("project-settings-access-app-skeleton.tpl.21bb94b1.svg").toString();